import React, { useState } from 'react'
import {
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  Tabs,
  Tab,
} from '@mui/material'
import boysSchedule from '../../images/tryouts/boys_tryouts_schedule.png'
import girlsSchedule from '../../images/tryouts/girls_tryouts_schedule.png'

const Tryouts = () => {
  const [tabValue, setTabValue] = useState(0)
  const registrationLink = 'https://system.gotsport.com/programs/8056966W4?reg_role=player'

  const scheduleImages = [
    {
      title: 'Boys Tryouts Schedule',
      image: boysSchedule,
    },
    {
      title: 'Girls Tryouts Schedule',
      image: girlsSchedule,
    },
  ]

  const displayedImages = [scheduleImages[tabValue]]

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  return (
    <Container maxWidth="lg" sx={{ pt: 15, pb: 6, backgroundColor: 'white', minHeight: '100vh' }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" sx={{ mb: 2, fontWeight: 'bold', color: 'black' }}>
          Atlantic United SC Tryouts
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: 'black' }}>
          Join our elite soccer program and take your skills to the next level. We're looking for
          dedicated players who are passionate about the game and ready to compete at a higher level.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          href={registrationLink}
          target="_blank"git 
          rel="noopener noreferrer"
        >
          Register Now
        </Button>
      </Box>

      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label="Boys Tryouts" />
          <Tab label="Girls Tryouts" />
        </Tabs>
      </Box>

      <Grid container spacing={1} justifyContent="center">
        {displayedImages.map((item, index) => (
          <Grid item xs={12} key={index}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', maxWidth: '600px', margin: '0 auto' }}>
              <CardMedia component="img" image={item.image} alt={item.title} sx={{ width: '100%', height: 'auto' }} />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}

export default Tryouts